"use client";

import { ArrowUp } from "lucide-react";
import { site } from "@/content/site";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="bg-surface-light dark:bg-surface-dark border-t border-line-light dark:border-line-dark">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <Logo size="small" />
          <p className="font-body text-[12px] md:text-[13px] text-faint-light dark:text-faint-dark text-center">
            {site.copyright}
          </p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 font-body text-[12px] md:text-[13px] font-medium text-brand-600 dark:text-brand-400 hover:gap-3 transition-all duration-300"
          >
            Back to Top
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
}
